import { styled } from 'styled-components';
export const StyledAvailability = styled.div `
  display: flex;
  margin-top: ${props => (props.$margin ? props.$margin : 0)}px;
  min-height: 13px;

  span {
    display: flex;
    flex-direction: row-reverse;
    align-items: baseline;

    span {
      font-size: 12px;
      .status__dot {
        margin-right: 10px;
        margin-inline-start: 0;
      }
    }
  }
`;
//# sourceMappingURL=styles.js.map